<template>
  <nav-bar
    class="c-navBar"
    :logo="logoImgUrl"
    :logout="logout"
    :user-info="user.profile"
  />
</template>

<script>
import NavBar from '@/shared/views/nav/navbar.vue';
import { name as userModuleName } from '@/modules/user/store';

import { mapState } from 'vuex';
import logoUrl from '@/assets/logo.svg';
import logoTrainingUrl from '@/assets/Asistencia-tecnologica-logo-training.svg';

export default {
  components: {
    NavBar,
  },
  props: {
    userInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedStudent: false,
      hasStudentSelected: false,
    };
  },
  computed: {
    ...mapState(userModuleName, ['user']),
    logoImgUrl() {
      if (this.isTrainingEnv()) return logoTrainingUrl;
      return logoUrl;
    },
  },

  methods: {
    logout() {
      this.$emit('logout');
    },
  },
};
</script>

<style scoped lang="scss">
.c-navBar ::v-deep .action-item-notification {
  display: none !important;
}
</style>
